/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../ReduxToolkit/Hooks";
import { Link, useLocation } from "react-router-dom";
import { LI, SVG, UL } from "../../AbstractElements";
import { Href } from "../../utils/Constant";
import { MenuItem, MenuListType } from "../../Types/Layout/Sidebar";
import { handlePined } from "../../ReduxToolkit/Reducer/LayoutSlice";
import { useTranslation } from "react-i18next";

const MenuLists: React.FC<MenuListType> = ({ menu, setActiveMenu, activeMenu, level, className }) => {
  const { pinedMenu } = useAppSelector((state) => state.layout);
  const { sidebarIconType } = useAppSelector((state) => state.themeCustomizer);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const ActiveNavLinkUrl = (path?: string) => {
    return location.pathname === path ? true : "";
  };
  const shouldSetActive = (item: MenuItem): boolean => {
    var returnValue = false;
    if (item?.path === location.pathname) returnValue = true;
    if (!returnValue && item?.children) {
      item?.children.every((subItem) => {
        returnValue = shouldSetActive(subItem);
        return !returnValue;
      });
    }
    return returnValue;
  };
  const handleClick = (item: string) => {
    setActiveMenu((prev: string[]) => {
      const next = [...prev];
      next[level] = item;
      next.splice(level + 1);
      return next;
    });
  };
  useEffect(() => {
    const matchedItem = menu?.find((item: MenuItem) => shouldSetActive(item));
    if (!matchedItem?.title) return;

    setActiveMenu((prev: string[]) => {
      if (prev[level] === matchedItem.title) return prev;
      const next = [...prev];
      next[level] = matchedItem.title;
      return next;
    });
  }, [location.pathname]);

  return (
    <>
      {menu?.map((item, index) => {
        const title = item.title ?? "";
        const isCurrent = activeMenu[level] === title;
        const isInitialMatch = !activeMenu[level] && shouldSetActive(item);
        const isExpanded = isCurrent || isInitialMatch;
        const isDirectPathActive = ActiveNavLinkUrl(item.path);
        const hasActiveChild =
          item.children?.some((innerItem) => shouldSetActive(innerItem)) || false;
        const isLinkActive = level === 0 ? isExpanded : isDirectPathActive || hasActiveChild;

        return (
          <LI
            key={index}
            className={`${level === 0 ? "sidebar-list" : ""} ${
              level === 0 && index === 0 ? "first-root-item" : ""
            } ${
              pinedMenu.includes(title) ? "pined" : ""
            } ${isExpanded ? "active current-section" : ""}`}
          >
            {level === 0 && (
              <>
                <span className="sidebar-item-bg" aria-hidden="true"></span>
                <span className="sidebar-item-pill" aria-hidden="true"></span>
                <span className="sidebar-item-curve sidebar-item-curve-top" aria-hidden="true"></span>
                <span
                  className="sidebar-item-curve sidebar-item-curve-bottom"
                  aria-hidden="true"
                ></span>
              </>
            )}
            {level === 0 && (
              <i className="fa fa-thumb-tack" onClick={() => dispatch(handlePined(title))}></i>
            )}
            <Link
              className={`${!className && level !== 2 ? "sidebar-link sidebar-title" : ""} ${
                className || level > 0 ? "sidebar-sublink" : ""
              } ${isLinkActive ? "active" : ""}`}
              to={item.path ? item.path : Href}
              onClick={() => handleClick(title)}
            >
              {item.icon && (
                <SVG className={`${sidebarIconType}-icon`} iconId={`${sidebarIconType}-${item.icon}`} />
              )}
              <span className={item.lanClass && item.lanClass}>{t(title)}</span>
              {item.children &&
                (isExpanded ? (
                  <div className="according-menu">
                    <i className="fa fa-angle-down" />
                  </div>
                ) : (
                  <div className="according-menu">
                    <i className="fa fa-angle-right" />
                  </div>
                ))}
            </Link>
            {item.children && (
              <UL
                className={`simple-list ${
                  level !== 0 ? "nav-sub-childmenu submenu-content" : "sidebar-submenu "
                }`}
                style={{
                  display: `${isExpanded ? "block" : "none"}`,
                }}
              >
                <MenuLists
                  menu={item.children}
                  activeMenu={activeMenu}
                  setActiveMenu={setActiveMenu}
                  level={level + 1}
                  className="sidebar-submenu"
                />
              </UL>
            )}
          </LI>
        );
      })}
    </>
  );
};

export default MenuLists;
